

export class TSolicitudResultadoAtestFitoViewModel {
    public IdSolicitudAtestFito: number;
    public FechaCreacion: Date;
    public IdEstado: number = 0;
    public IdTipoSolicitud: number = 0;
    public IdEstadoDescripcion: string;
    public IdTipoSolicitudDescripcion: string;
    public CodigoTipoSolicitud: string;
    public NombreAgenteControl: string;
    public IdUsuarioAc: number | null;
    public RefAtestFito: string;
    public FechaInspeccion: Date;
}

export class TDatosResponsableCaAcViewModel {

    public IdSolicitudAtestFito: number;
    public FechaCreacion: Date;
    public IdEstado: number = 0;
    public IdTipoSolicitud: number = 0;
    public IdResultadoSolicitudAtestFito: number | null = null;
    public IdEstadoDescripcion: string;
    public IdTipoSolicitudDescripcion: string;
    public CodigoTipoSolicitud: string;
    public RefAtestFito: string;
    public NombreTecResponsable: string;
    public NombreAgenteControl: string;
    public FechaValidezInicio: Date | null;
    public FechaValidezFin: Date | null;
    public Observaciones: string;
    public IdUsuarioAc: number | null;
    public FechaInspeccion: Date;
    public FechaComunicacionCa: Date | null;
    public FechaFinalizacion: Date | null;
}





